
















































import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import AxisConfigService from '@/domain/matrix-config/service/axis-config.service';
import AxisConfig from '@/domain/matrix-config/entity/axis-config.entity';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import AxisScaleSettings from './axis-scale-settings.component.vue';

@Component({
  components: {
    AxisScaleSettings,
  },
})
export default class AxisSettings extends Vue {
  loading: boolean = true;

  loadingSave: boolean = false;

  axisConfigs: AxisConfig[] = [];

  hasUpdateAxisAuthority: boolean = false;

  inputLabel(value: string, index: number) {
    this.axisConfigs[index].label = value;
  }

  inputMinValue({ value, index }: any, axisIndex: number) {
    this.axisConfigs[axisIndex].scaleLevels[index].minValue = parseFloat(value);
  }

  inputMaxValue({ value, index }: any, axisIndex: number) {
    this.axisConfigs[axisIndex].scaleLevels[index].maxValue = parseFloat(value);
  }

  saveConfigurations() {
    const { form }: any = this.$refs;
    if (form.validate()) {
      this.loadingSave = true;
      AxisConfigService.updateAxisConfigs(this.axisConfigs)
        .then(() => {
          this.loadAxisConfigs();
        }).catch(VbSnackbarService.handleHttpError)
        .finally(() => { this.loadingSave = false; });
    }
  }

  private loadAxisConfigs() {
    this.loading = true;
    AxisConfigService.getAxisConfigs()
      .then((axisConfigs: AxisConfig[]) => {
        this.axisConfigs = axisConfigs;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loading = false; });
  }

  private loadUpdateAxisAuthority() {
    AuthorityStore.hasAuthority([AuthorityEnum.UPDATE_AXIS_SETTINGS])
      .then((hasUpdateAxisAuthority) => {
        this.hasUpdateAxisAuthority = hasUpdateAxisAuthority;
      });
  }

  created() {
    this.loadAxisConfigs();
    this.loadUpdateAxisAuthority();
  }
}
